import React from "react";
import { useNavigate } from "react-router-dom";
import { IntentGroup, TestSet, TestRun } from "../../model_gen/evaluation";

interface Props {
  intentGroup: IntentGroup | null;
  testSet: TestSet | null;
  testRun: TestRun | null;
  testSetId?: string;
}

const TestRunBreadcrumb: React.FC<Props> = ({
  intentGroup,
  testSet,
  testRun,
  testSetId,
}) => {
  const navigate = useNavigate();

  return (
    <nav className="mb-6">
      <ol className="flex items-center gap-2 text-sm">
        <li>
          <button
            onClick={() => navigate("/intent-groups")}
            className="text-muted-foreground hover:text-maitai-green transition-colors font-gc-reg"
          >
            Intent Groups
          </button>
        </li>
        <li className="text-muted-foreground/40">/</li>
        {intentGroup && (
          <>
            <li>
              <button
                onClick={() => navigate(`/intent-group/${intentGroup.id}`)}
                className="text-muted-foreground hover:text-maitai-green transition-colors font-gc-reg"
              >
                {intentGroup.intent_name}
              </button>
            </li>
            <li className="text-muted-foreground/40">/</li>
            <li>
              <button
                onClick={() =>
                  navigate(`/intent-group/${intentGroup.id}?tab=testsets`)
                }
                className="text-muted-foreground hover:text-maitai-green transition-colors font-gc-reg"
              >
                Test Sets
              </button>
            </li>
            <li className="text-muted-foreground/40">/</li>
          </>
        )}
        {testSet && (
          <>
            <li>
              <button
                onClick={() =>
                  navigate(
                    `/intent-group/${intentGroup?.id}/testsets/${testSetId}`
                  )
                }
                className="text-muted-foreground hover:text-maitai-green transition-colors font-gc-reg"
              >
                {testSet.name}
              </button>
            </li>
            <li className="text-muted-foreground/40">/</li>
          </>
        )}
        <li>
          <span className="text-maitai-green font-gc-med">
            {testRun ? `Test Run ${testRun.id}` : "Test Run"}
          </span>
        </li>
      </ol>
    </nav>
  );
};

export default TestRunBreadcrumb;
